import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import { Fragment, useContext } from 'react'
import { useCreditApplications } from '../../../api/react-query'
import TextContainer from '../../../components/TextContainer'
import Spacings from '../../../figma/tokens/Spacings'
import { BorderContainer, BorderContainerHeader, CustomerIdContext } from '../../../helpers/CreditOnCardHelpers'
import TextKeys from '../../../libs/TextKeys'
import FigmaBox from '../../../mynt-components/components/FigmaBox'
import MyntLoader from '../../../mynt-components/components/MyntLoader'
import CreditApplicationCard from './CreditApplicationCard'
import { isFollowableApplication } from './creditApplicationHelpers'

const CreditApplications = () => {
  const customerId = useContext(CustomerIdContext)
  const { data, isLoading } = useCreditApplications(customerId)

  if (!data && isLoading) return <MyntLoader />

  const applications = (data ?? []).filter((application) => isFollowableApplication(application.requestStatus))

  return (
    <BorderContainer fullWidth>
      <BorderContainerHeader>
        <TextContainer textKey={TextKeys.creditOnCardCreditSettingsHeading} text="Applications" />
      </BorderContainerHeader>

      {applications.length === 0 ? (
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
          }}
        >
          No applications yet
        </Typography>
      ) : (
        <FigmaBox fullWidth gap={Spacings.medium}>
          {applications.map((application, index) => (
            <Fragment key={application.requestId}>
              {index > 0 && <Divider />}
              <CreditApplicationCard application={application} />
            </Fragment>
          ))}
        </FigmaBox>
      )}
    </BorderContainer>
  )
}

export default CreditApplications
